<div class="container">
    <div class="card">
        <div class="task-head">
            <h4>Tasked location</h4>
        </div>
        <div class="preview-details">
            <div>
                <span style="color: gray">Task Name:</span><span class="preview-content"> {{ taskname }}</span>
            </div>
              <div>
                <ng-container *ngIf="questionId; else taskBlock">
                  <span style="color: gray">Question ID:</span>
                  <span class="preview-content">{{ questionId }}</span>
                </ng-container>

               <ng-template #taskBlock>
                  <span style="color: gray">Task ID:</span>
                  <span class="preview-content">{{ taskid }}</span>
                </ng-template>
              </div>
        </div>

        <div leaflet #map id="map" style="
                            height: calc(95vh - 350px) !important;
                            width: 100%; margin-bottom: 30px;
                          ">
            <div id="homeButton" (click)="viewHome($event)" title="View Home">
                <img src="../../../assets/map-icons/home-icon.svg" />
            </div>
            <!-- <div class="dms-preview">{{ latLngDMS }}</div> -->
            <div class="content" [ngStyle]="{ height: observationCoordinatesDisplay.length > 0 ? '150px' : '90px' }">
                <label style="padding-bottom: 5px; font-size: 15px;">AREA OF INTEREST</label>
                <div style="font-size: small">
                    <p style="margin-bottom: 5px; color: white;">
                        <label style="color: lightgray">Geometry:</label>
                        {{this.taskTarget.type}}
                    </p>
                    <p>
                        <span *ngIf="cordinateLabel === 'Tipping Coordinates'" class="tip-dot"></span>
                        <label style="color: lightgray">{{cordinateLabel}} (Lng, Lat):</label><span>
                            [{{ coordinatesPair[0] }}, {{ coordinatesPair[1] }}<span *ngIf="hasMoreCoordinates">...</span>]
    
                            <img style="
                     margin: 3px;height: 20px;position: absolute;top: 0;right: -32px;width: 20px;
                    " src="../../../assets/images/mark.png" [matTooltipClass]="'target-tooltip'" [matTooltip]="coordinates | json"
                                matTooltipPosition="left" /></span>
    
                    </p>
                    <p *ngIf="observationCoordinatesDisplay.length > 0" style="margin-bottom: 5px; color: white;">
                        <label style="color: lightgray">Geometry:</label>
                        {{ observationType }}
                    </p>
          <p *ngIf="observationCoordinatesDisplay.length > 0">
            <span class="cue-dot"></span>
            <label style="color: lightgray">Cueing Coordinates (Lng, Lat):</label><span>
            [{{ observationCoordinatesPair[0] }}, {{ observationCoordinatesPair[1] }}<span *ngIf="hasMoreObservationCoordinates">...</span>]
            <span [matTooltipClass]="'target-tooltip'" [matTooltip]="observationCoordinatesDisplay | json" matTooltipPosition="left">
                <img style="
                height: 20px;
                position: absolute;
                top: 0;
                right: -32px;
                width: 20px;
                " src="../../../assets/images/mark.png" /></span>
            </span>
          </p>
                </div>
                <div>
                    <div class="dms">{{ latLngDMS }}</div>
                </div>
            </div>
        </div>

        

        <div id="zoomDiv">
            <div style="display: flex">
                <div style="width: 50%">Zoom level</div>
                {{ zoomLevel }}
            </div>
            <div style="display: flex">
                <div style="width: 50%">Distance</div>
                {{ mapDistance | number : "0.0-2" }} km
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center" style="margin-top: -15px">
        <button mat-button class="btn" (keydown)="onKeyPress($event, 'NO')" (click)="onNoClick('NO')">
            Close
        </button>
    </div>
</div>
